export const vnextOpContracts = {
  addRole: {
    requiredArgs: ["label"],
    optionalArgs: ["id", "transient", "multiple", "position", "size"],
    preconditions: ["role label must be unique"],
    effects: ["create role", "increment version"],
  },
  addThread: {
    requiredArgs: ["roleId"],
    optionalArgs: ["id", "className", "label", "preStateId", "postStateId"],
    preconditions: ["role must exist"],
    effects: ["create thread", "ensure start/end states", "increment version"],
  },
  addActivityToThread: {
    requiredArgs: ["threadId"],
    optionalArgs: ["id", "label", "kind", "type", "preStateId", "postStateId"],
    preconditions: ["thread must exist", "thread must have start/end states"],
    effects: ["create activity", "may create bridge state on append", "increment version"],
  },
  addActivityToRole: {
    requiredArgs: ["roleId"],
    optionalArgs: ["id", "label", "kind", "type", "threadLabel", "preStateId", "postStateId"],
    preconditions: ["role must exist"],
    effects: ["create thread", "create activity", "increment version"],
  },
  updateActivity: {
    requiredArgs: ["id"],
    optionalArgs: ["label", "preStateId", "postStateId", "hidden"],
    preconditions: ["activity must exist"],
    effects: ["update activity fields", "increment version"],
  },
  addConnection: {
    requiredArgs: ["interactions"],
    optionalArgs: ["connectionId"],
    preconditions: ["at least two interaction ids"],
    effects: ["create or merge connection", "increment version"],
  },
  addInteraction: {
    requiredArgs: ["sourceActivityId", "targetActivityId"],
    optionalArgs: ["connectionId", "sourceActionId", "targetActionId"],
    preconditions: [
      "source/target activities must exist",
      "source/target must be interaction kind",
      "source/target must belong to distinct roles",
    ],
    effects: ["create or merge connection", "increment version"],
  },
  deleteState: {
    requiredArgs: ["id"],
    optionalArgs: [],
    preconditions: ["state id provided"],
    effects: ["remove state and dependent activities", "increment version"],
  },
  deleteEntity: {
    requiredArgs: ["type", "id"],
    optionalArgs: [],
    preconditions: ["supported type provided"],
    effects: ["cascade delete by entity type", "increment version"],
  },
  validateRad: {
    requiredArgs: [],
    optionalArgs: [],
    preconditions: [],
    effects: ["check invariants"],
  },
};

export const summarizeContractsAsCapabilities = (contracts = vnextOpContracts) =>
  Object.fromEntries(
    Object.entries(contracts).map(([op, contract]) => [
      op,
      `vnext_native(required:${contract.requiredArgs.length}, optional:${contract.optionalArgs.length})`,
    ])
  );
